import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Loader } from "components/Loader";
import { checkFirstLevelApproverPermission } from "services/utils/HelperFunction";
import { getColorWorkingHours } from "services/utils/Status";
import { OtReports } from "./OtReports";
import { firstLevelWorkingHours, workingHoursHeader } from "../ReportHeaders";
import { tableRowSx } from "services/constants";
import {
  AccountBalance,
  KeyboardArrowDown,
  ChevronRight,
  DriveFileRenameOutline,
  DownloadForOffline,
  Search,
} from "@mui/icons-material";
import moment from "moment";
import styled from "styled-components";
import * as Mui from "@mui/material";
import {
  themes,
  reports,
  defaultAllSelection,
  punchInDetails,
  optionalAvathar,
  adminRoleName,
} from "services/constants";
import { showToast } from "services/utils/Status";
import BSDateRangePicker from "pages/MyZone/Status/DateRangePicker";
import { PunchDetails } from "./PunchDetails";
import {
  setDepartmentId,
  setDepartmentName,
} from "services/Redux/userManagament";
import sessionHandling from "services/utils/notificationUtils";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { attendanceStatusHalfBox } from "services/constants/Styles";
import { EditCheckInOut } from "pages/TeamZone/Attendance/AttendanceStatus/Status/EditCheckInOut";
import { tooltipStyleProps } from "services/constants/Styles";
import { InfoMessage } from "components/CustomComponents/CustomButton";

export const WorkingHours = ({ setShowReport, reportName }) => {
  const dispatch = useDispatch();
  const {
    token,
    domain,
    globalSearchValue,
    userDetails: currentUserDetails,
    userScreenAccess,
    topbarCompanyId,
    topbarCompanyName,
  } = useSelector((state) => state.tokenReducer);
  const [departmentIdValue, setDepartmentIdValue] = useState(99999);
  const { departmentId, departmentName } = useSelector(
    (state) => state.userReducer
  );
  const [loading, setLoading] = useState(true);
  const [selectedDateRange, setSelectedDateRange] = useState("");
  const [departmentData, setDepartmentData] = useState([]);
  const [expandedSubMenuAnchorEl, setExpandedSubMenuAnchorEl] = useState(null);
  const [removeExpand, setRemoveExpand] = useState(false);
  const [punchExports, setPunchExports] = useState(false);
  const [exportOTime, exportOverTimeReport] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().subtract(7, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().subtract(1, "days").format("YYYY-MM-DD")
  );
  const [shiftCatagoryName, setShiftCatagoryName] = useState("");
  const [personExpandableId, setPersonExpandableId] = useState(0);
  const [breakExpandableDate, setBreakExpandableDate] = useState(0);
  const [getReportedData, setGetReportedData] = useState(false);
  const [updatedDetailReportData, setUpdatedDetailsReportData] = useState([]);
  const [reportedType, setReportedType] = useState(reportName);
  const [workingHoursDetails, setWorkingHoursDetails] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [page, setLeavePage] = useState(0);
  const [rowsPerPage, setLeaveRowsPerPage] = useState(25);
  const [punchDetailsData, setPunchDetailsData] = useState([]);
  const [masterPunchDetails, setmasterPunchDetails] = useState([]);
  const [userLoader, setUserLoader] = useState(false);
  const [shiftDetails, setShiftDetails] = useState({});
  const [openSidePeek, setOpenSidePeek] = useState(false);
  const [editState, setEditState] = useState(false);
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));

  const handleChangePage = (event, newPage) => {
    setLeavePage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setLeaveRowsPerPage(parseInt(event.target.value, 10));
    setLeavePage(0);
  };
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [fetchSummarizedReport, setFetchSummarizedReport] = useState(true);
  const [fetchPunchDetails, setFetchPunchDetails] = useState(true);

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const filteredData = departmentData.filter((data) =>
    data.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    const recallApi = () => {
      setEditState(false);
      getCheckInCheckOutDetails(personExpandableId);
    };
    if (editState && !openSidePeek) {
      recallApi();
    }
  });

  useEffect(() => {
    const fetchDepartmentData = async () => {
      try {
        const response = await fetch(
          `${domain}get-department/?user_id=${currentUserDetails.id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          setDepartmentData([]);
          const departmentDataWithLabel = res.map((obj) => ({
            ...obj,
            label: obj.department_name,
          }));
          const allDepartment = {
            id: defaultAllSelection,
            label: "All",
            departmentname: "All",
          };
          setDepartmentData([allDepartment, ...departmentDataWithLabel]);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    fetchDepartmentData();
  }, [currentUserDetails.id, domain, token]);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${domain}punchin-details/?user_id=${currentUserDetails.id}&shift_id=99999&department_id=${departmentId}&start_date=${fromDate}&end_date=${toDate}&company_id=${topbarCompanyId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          setPunchDetailsData(res);
          setmasterPunchDetails(res);
          setLoading(false);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    if (fetchPunchDetails && reportedType === "Punch details") {
      fetchDepartmentData();
      setFetchPunchDetails(false);
    }
  }, [
    currentUserDetails.id,
    departmentId,
    domain,
    endDate,
    fetchPunchDetails,
    fromDate,
    reportedType,
    setFetchPunchDetails,
    startDate,
    toDate,
    token,
    topbarCompanyId,
  ]);

  useEffect(() => {
    setBreakExpandableDate(0);
    setPersonExpandableId(0);
    const filteredResults = masterPunchDetails.filter((item) =>
      punchInDetails.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setPunchDetailsData(filteredResults);
    setLeavePage(0);
  }, [globalSearchValue, masterPunchDetails]);

  useEffect(() => {
    if (topbarCompanyId) {
      setFetchSummarizedReport(true);
      setFetchPunchDetails(true);
    }
  }, [topbarCompanyId]);

  useEffect(() => {
    const getWorkingHoursDetails = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${domain}summarized-detailed-workinghours/?user_id=${currentUserDetails.id}&start_date=${startDate}&end_date=${endDate}&department_id=${departmentId}&shift_id=99999&company_id=${topbarCompanyId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          setWorkingHoursDetails(res);
          setMasterDataForSearch(res);
          setLoading(false);
          if (
            reportedType !== "Summarized working hours" &&
            reportedType !== "Punch details"
          ) {
            setGetReportedData(true);
          }
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    if (fetchSummarizedReport && reportedType !== "Punch details") {
      getWorkingHoursDetails();
      setFetchSummarizedReport(false);
    }
  }, [
    currentUserDetails.id,
    departmentId,
    domain,
    endDate,
    fetchSummarizedReport,
    reportedType,
    startDate,
    token,
    topbarCompanyId,
  ]);

  useEffect(() => {
    const getReportDetails = () => {
      let Urls = [],
        overAllData = [];
      workingHoursDetails.forEach((element) => {
        let urls = [
          ...Urls,
          `${domain}individual_details_working_hours/?user_id=${element.user_id}&start_date=${startDate}&end_date=${endDate}`,
        ];
        Urls = urls;
      });
      Promise.all(
        Urls.map((url) =>
          fetch(url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }).then((r) => r.json())
        )
      )
        .then(function (responses) {
          return Promise.all(
            responses.map(function (response) {
              if (
                response?.error !== "No data found for the given date range"
              ) {
                overAllData = [...overAllData, ...response.checkin_details];
                setUpdatedDetailsReportData(overAllData);
                return overAllData;
              } else {
                return overAllData;
              }
            })
          );
        })
        .catch((error) => console.log(error));
    };
    if (getReportedData) {
      getReportDetails();
      setGetReportedData(false);
    }
  }, [domain, endDate, getReportedData, startDate, token, workingHoursDetails]);

  const handleStartDate = async (startDate, endDate) => {
    setPersonExpandableId(0);
    setStartDate(
      moment(new Date(startDate.split("/").reverse().join("-"))).format(
        "YYYY-MM-DD"
      )
    );
    setEndDate(
      moment(new Date(endDate.split("/").reverse().join("-"))).format(
        "YYYY-MM-DD"
      )
    );
    setFromDate(
      moment(new Date(startDate.split("/").reverse().join("-"))).format(
        "YYYY-MM-DD"
      )
    );
    setToDate(
      moment(new Date(endDate.split("/").reverse().join("-"))).format(
        "YYYY-MM-DD"
      )
    );
    setSelectedDateRange(
      `${moment(new Date(startDate.split("/").reverse().join("-"))).format(
        "DD-MM-YYYY"
      )} - ${moment(new Date(endDate.split("/").reverse().join("-"))).format(
        "DD-MM-YYYY"
      )}`
    );
    if (reportedType === "Punch details") {
      setFetchPunchDetails(true);
    } else {
      setFetchSummarizedReport(true);
    }
  };

  const summarizeExport = () => {
    if (workingHoursDetails.length === 0) {
      showToast("error", "No data available");
    } else {
      let dataPreparation = [];
      workingHoursDetails.forEach((element) => {
        let overAllData = {
          employee_name: element?.employee_name,
          employee_id: element?.employee_id,
          total_days: element?.total_days,
          assigned_shift: element?.assigned_shift,
          week_off: element?.week_off_count,
          holiday: element?.holiday_count,
          leaves: element?.leave_count,
          absent: element?.absent_count,
          present: element?.present_count,
          permissionshours: element?.no_of_permission,
          late: element?.no_of_late,
          break: element?.no_of_break,
          workinghours: element?.total_working_hours,
          shiftworkinghours: element?.shift_working_hours,
          othours: element?.ot_hours,
          total_break_hours: element?.total_break_hours,
          latecomminghours: element?.late_coming_hours,
          earlyleavinghours: element?.early_leaving_hours,
        };
        dataPreparation = [...dataPreparation, overAllData];
      });
      const companyName = ["Company Name"];
      const department = ["Department Name"];
      const date = ["Date"];
      const GeneratedOn = ["Report Generated On"];
      companyName.push(topbarCompanyName);
      department.push(departmentName);
      date.push(`${startDate} to ${endDate}`);
      GeneratedOn.push(moment(new Date()).format("DD/MM/YYYY, hh:mm a"));
      const items = dataPreparation;
      const TableHead = ["Employee Name"];
      TableHead.push("Employee Id");
      TableHead.push("Total Days");
      TableHead.push("Assigned Shifts");
      TableHead.push("Week Off");
      TableHead.push("Holiday");
      TableHead.push("Leave Days");
      TableHead.push("Absent Days");
      TableHead.push("Present Days");
      TableHead.push("No. of Permission");
      TableHead.push("No. of Late");
      TableHead.push("No. of Break");
      TableHead.push("Total Working Hours");
      TableHead.push("Total Shift Hours");
      TableHead.push("OT Hours");
      TableHead.push("Total Break Hours");
      TableHead.push("Late Coming Hours");
      TableHead.push("Early Leaving Hours");

      const replacer = (key, value) => (value === null ? "" : value);
      const header = Object.keys(items[0]);
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(TableHead.join(","));
      csv.unshift(",");
      csv.unshift(GeneratedOn.join(","));
      csv.unshift(date.join(","));
      csv.unshift(department.join(","));
      csv.unshift(companyName.join(","));
      csv = csv.join("\r\n");
      const ConvertData = csv;
      const element = document.createElement("a");
      const file = new Blob([ConvertData], {
        type: "text/plain",
      });
      element.href = URL.createObjectURL(file);
      element.download = "SummarizedReport.csv";
      document.body.appendChild(element);
      element.click();
    }
  };

  const getCheckInCheckOutDetails = async (userid) => {
    setUserLoader(true);
    try {
      const response = await fetch(
        `${domain}individual_details_working_hours/?user_id=${userid}&start_date=${startDate}&end_date=${endDate}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        }
      );
      const res = await response.json();
      if (response.ok) {
        setUserDetails(res);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      setUserDetails([]);
      showToast("error", error.message);
    } finally {
      setUserLoader(false);
    }
  };

  const exportDetailedReport = () => {
    if (updatedDetailReportData.length !== 0) {
      let dataPreparation = [];
      updatedDetailReportData.forEach((element) => {
        let overAllData = {
          user_name: element?.user_name,
          employee_id: element?.employee_id,
          date: element?.date,
          shift: element?.shift ? element.shift : "",
          status: element?.type,
          checkInTime: element?.check_in_time_formatted,
          BreakTime: element?.break_hours,
          OverTime: element?.over_time,
          Permission: element?.permission_details?.individual_permission_time
            ? element?.permission_details?.individual_permission_time
            : "",
          CheckOutTime: element?.check_out_time_formatted,
          working_hours: element?.working_hours,
          leaveCreditHours: element?.Leave_credit_hours,
        };
        dataPreparation = [...dataPreparation, overAllData];
      });
      if (dataPreparation.length !== 0) {
        const companyName = ["Company Name"];
        const department = ["Department Name"];
        const date = ["Date"];
        const GeneratedOn = ["Report Generated On"];
        companyName.push(topbarCompanyName);
        department.push(departmentName);
        date.push(`${startDate} to ${endDate}`);
        GeneratedOn.push(moment(new Date()).format("DD/MM/YYYY, hh:mm a"));
        const items = dataPreparation;
        const TableHead = ["Employee Name"];
        TableHead.push("Employee Id");
        TableHead.push("Date");
        TableHead.push("Shift");
        TableHead.push("Status");
        TableHead.push("CheckIn Time");
        TableHead.push("Break Hours");
        TableHead.push("Over Time");
        TableHead.push("Permission Hours");
        TableHead.push("CheckOut Time");
        TableHead.push("Working Hours");
        TableHead.push("Leave Credit Hours");

        const replacer = (key, value) => (value === null ? "" : value);
        const header = Object.keys(items[0]);
        let csv = items.map((row) =>
          header
            .map((fieldName) => JSON.stringify(row[fieldName], replacer))
            .join(",")
        );
        csv.unshift(TableHead.join(","));
        csv.unshift(",");
        csv.unshift(GeneratedOn.join(","));
        csv.unshift(date.join(","));
        csv.unshift(department.join(","));
        csv.unshift(companyName.join(","));
        csv = csv.join("\r\n");
        const ConvertData = csv;
        const element = document.createElement("a");
        const file = new Blob([ConvertData], {
          type: "text/plain",
        });
        element.href = URL.createObjectURL(file);
        element.download = "DetailedReports.csv";
        document.body.appendChild(element);
        element.click();
      } else {
        showToast("error", "No data available");
      }
    } else {
      showToast("error", "Preparing data, please hold on a moment...");
    }
  };
  useEffect(() => {
    const FilterDockets = () => {
      const cols =
        masterDataForSearch[0] && Object.keys(masterDataForSearch[0]);
      return masterDataForSearch.filter((r) =>
        cols.some((c) =>
          r[c]
            ? r[c]
                .toString()
                .toLowerCase()
                .indexOf(globalSearchValue.toLowerCase()) > -1
            : null
        )
      );
    };
    setWorkingHoursDetails(FilterDockets());
    setLeavePage(0);
  }, [globalSearchValue, masterDataForSearch]);

  return (
    <React.Fragment>
      <Mui.Grid sx={{ paddingTop: 1 }}>
        <BackArrow actionFunction={() => setShowReport(false)} />
      </Mui.Grid>
      <Mui.Grid container xs={12}>
        <Mui.Grid item xs={3}>
          <Mui.Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              width: 270,
              height: 120,
              backgroundColor: "#FFF8E5",
            }}
          >
            <Mui.Grid container sx={{ paddingLeft: 2 }}>
              <Mui.Grid
                xs={2}
                container
                justifyContent="center"
                alignItems="center"
                sx={{
                  width: 40,
                  height: 40,
                  backgroundColor: "#FFD83A",
                  borderRadius: "50%",
                }}
              >
                <AccountBalance
                  style={{ color: "white", alignItems: "center" }}
                  fontSize="medium"
                />
              </Mui.Grid>
              &nbsp; &nbsp;
              <Mui.Grid xs={7}>
                <Mui.Typography
                  style={{
                    fontSize: "18px",
                    fontWeight: "800",
                    textTransform: "capitalize",
                  }}
                >
                  {departmentName?.length > 10 ? (
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={departmentName}
                    >
                      <span>{`${departmentName.substring(0, 10)}..`}</span>
                    </Mui.Tooltip>
                  ) : (
                    departmentName
                  )}
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    fontSize: 15,
                    fontWeight: 600,
                  }}
                >
                  {shiftCatagoryName?.length > 10 ? (
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={shiftCatagoryName}
                    >
                      <span>{`${shiftCatagoryName.substring(0, 10)}..`}</span>
                    </Mui.Tooltip>
                  ) : (
                    shiftCatagoryName
                  )}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={2} sx={{ paddingRight: 2 }}>
                <Mui.IconButton
                  onClick={(e) => setExpandedSubMenuAnchorEl(e.currentTarget)}
                >
                  <KeyboardArrowDown />
                </Mui.IconButton>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Box>

          <Mui.Popover
            anchorEl={expandedSubMenuAnchorEl}
            open={Boolean(expandedSubMenuAnchorEl)}
            onClose={() => {
              setExpandedSubMenuAnchorEl(null);
              setSearchQuery("");
            }}
            anchorReference="anchorPosition"
            anchorPosition={{ top: 326, left: 520 }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            PaperProps={{
              style: {
                maxHeight: "200px",
                width: "270px",
                overflowY: "auto",
              },
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "200px",
              }}
            >
              <Mui.TextField
                variant="outlined"
                size="small"
                margin="dense"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearchChange}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <Mui.InputAdornment position="end">
                      <Search />
                    </Mui.InputAdornment>
                  ),
                }}
              />
              <div style={{ flex: 1, overflowY: "auto", height: "50px" }}>
                {filteredData.length > 0 ? (
                  filteredData.map((data) => (
                    <Mui.MenuItem
                      onClick={() => {
                        if (data && data.label) {
                          setDepartmentId(data.id);
                          setDepartmentName(data.department_name);
                          setShiftCatagoryName(data.shift_category_name);
                          localStorage.setItem(
                            "approveLeaveDepartmentId",
                            data.id
                          );
                          localStorage.setItem(
                            "approveLeaveDepartmentName",
                            data.label
                          );
                          dispatch(setDepartmentName(data.label));
                          dispatch(setDepartmentId(data.id));
                          setPersonExpandableId(0);
                          setRemoveExpand(true);
                          if (reportedType !== "Punch details") {
                            setFetchSummarizedReport(true);
                          } else {
                            setFetchPunchDetails(true);
                          }
                        }
                        setExpandedSubMenuAnchorEl(null);
                      }}
                    >
                      {data.label}
                    </Mui.MenuItem>
                  ))
                ) : (
                  <Mui.MenuItem disabled>No data available</Mui.MenuItem>
                )}
              </div>
            </div>
          </Mui.Popover>
        </Mui.Grid>
        <ContentGrid
          item
          xs={12}
          sm={12}
          md={8}
          lg={9}
          sx={{ paddingRight: 2 }}
        >
          <Mui.Grid
            container
            style={{
              display: "flex",
              flexDirection: "row",
              alignSelf: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <Mui.Stack
              style={{
                width: 320,
                marginLeft: 5,
              }}
            >
              <BSDateRangePicker
                handleStartDate={handleStartDate}
                showToday={reportedType === "Punch details" ? true : false}
                triggerDate={true}
                includeCurrentDate={
                  reportedType === "Punch details" ? true : false
                }
              />
            </Mui.Stack>
            &nbsp;&nbsp;
            <Mui.Autocomplete
              disablePortal
              id="combo-box-demo"
              size="small"
              style={{
                width: 290,
                marginLeft: 5,
                marginRight: 5,
              }}
              value={reportedType}
              options={reports}
              ListboxProps={{ style: { maxHeight: "150px" } }}
              filterOptions={(options, state) => {
                return options.filter((option) =>
                  option.label
                    .toLowerCase()
                    .includes(state.inputValue.toLowerCase())
                );
              }}
              renderOption={(props, option) => {
                return <li {...props}>{option.label}</li>;
              }}
              onChange={(event, value) => {
                if (value) {
                  setReportedType(value.label);
                  setPersonExpandableId(0);
                  setRemoveExpand(true);
                  if (value.label === "Punch details") {
                    setFetchPunchDetails(true);
                  } else {
                    setFetchSummarizedReport(true);
                  }
                }
              }}
              renderInput={(params) => (
                <Mui.TextField
                  {...params}
                  value={reportedType}
                  label="Report Type"
                  placeholder="Select the report type"
                  size="small"
                />
              )}
            />
            <Mui.Grid
              sx={{
                display: "flex",
                flexDirection: "row",
                mt: -1.5,
              }}
            >
              <Mui.IconButton
                onClick={() => {
                  reportedType === "Summarized working hours"
                    ? summarizeExport()
                    : reportedType === "Punch details"
                    ? setPunchExports(true)
                    : reportedType === "Detailed working hours"
                    ? exportDetailedReport()
                    : exportOverTimeReport(true);
                }}
              >
                <DownloadForOffline
                  size="large"
                  sx={{ color: themes.downloadIconColor, fontSize: 50 }}
                />
              </Mui.IconButton>
            </Mui.Grid>
          </Mui.Grid>
        </ContentGrid>
      </Mui.Grid>
      <Mui.Grid
        container
        spacing={2}
        sx={{ paddingTop: { xs: 1, md: 1, sm: 1, lg: 1 } }}
      ></Mui.Grid>
      {(reportedType === "Summarized working hours" ||
        reportedType === "Detailed working hours") &&
      !loading ? (
        <Mui.Grid container>
          <Mui.TableContainer
            sx={{ mt: 2, width: "100%", maxHeight: 660, ml: 2, mr: 2 }}
          >
            <Mui.Table className="border">
              <Mui.TableHead
                sx={{
                  backgroundColor: themes.primary,
                  position: "sticky",
                  top: -1,
                  zIndex: 10,
                }}
              >
                <Mui.TableRow sx={tableRowSx}>
                  {reportedType === "Detailed working hours" ? (
                    <Mui.TableCell></Mui.TableCell>
                  ) : null}
                  {firstLevelWorkingHours.map((header) => (
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                      }}
                    >
                      {header.header}
                    </Mui.TableCell>
                  ))}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {workingHoursDetails.length === 0 && loading === false ? (
                  <InfoMessage dataLength={workingHoursDetails?.length} />
                ) : (
                  workingHoursDetails
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    .map((element) => (
                      <>
                        <Mui.TableRow sx={tableRowSx}>
                          {reportedType === "Detailed working hours" ? (
                            <Mui.TableCell>
                              {element?.user_id === personExpandableId ? (
                                <Mui.IconButton
                                  onClick={() => {
                                    setBreakExpandableDate(0);
                                    setPersonExpandableId(0);
                                  }}
                                >
                                  <KeyboardArrowDown />
                                </Mui.IconButton>
                              ) : (
                                <Mui.IconButton
                                  onClick={() => {
                                    setBreakExpandableDate(0);
                                    setUserDetails([]);
                                    setPersonExpandableId(element?.user_id);
                                    getCheckInCheckOutDetails(element?.user_id);
                                  }}
                                  style={{
                                    padding: "0px",
                                  }}
                                >
                                  <ChevronRight />
                                </Mui.IconButton>
                              )}
                            </Mui.TableCell>
                          ) : null}
                          {firstLevelWorkingHours.map((header) => (
                            <>
                              {header?.header === "Employee Name" ? (
                                <Mui.TableCell
                                  sx={{
                                    border: 1,
                                    borderColor: themes.primary,
                                  }}
                                >
                                  <Mui.Stack direction="Row">
                                    <Mui.Avatar
                                      sx={{ width: 23, height: 23 }}
                                      alt={element?.employee_name
                                        ?.charAt(0)
                                        .toUpperCase()}
                                      src={
                                        element?.image_url ?? optionalAvathar
                                      }
                                    />
                                    <Mui.Typography
                                      sx={{
                                        paddingLeft: 1,
                                      }}
                                    >
                                      {element.employee_name}
                                    </Mui.Typography>
                                  </Mui.Stack>
                                </Mui.TableCell>
                              ) : (
                                <Mui.TableCell sx={{ color: themes.headLine }}>
                                  {element[header.key] ||
                                  element[header.key] === 0
                                    ? element[header.key]
                                    : "N/A"}
                                </Mui.TableCell>
                              )}
                            </>
                          ))}
                        </Mui.TableRow>

                        {personExpandableId === element?.user_id &&
                        userLoader ? (
                          <Mui.TableRow sx={tableRowSx}>
                            <Mui.TableCell
                              colSpan={15}
                              style={{ textAlign: "center" }}
                            >
                              <Mui.Grid container justifyContent="center">
                                <Loader info="loading" />
                              </Mui.Grid>
                            </Mui.TableCell>
                          </Mui.TableRow>
                        ) : personExpandableId === element?.user_id ? (
                          <Mui.TableRow sx={tableRowSx}>
                            <Mui.TableCell colSpan={15}>
                              <Mui.TableContainer
                                sx={{
                                  marginTop: 0,
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                  width: "100%",
                                  maxHeight: "650px",
                                }}
                                className="w-96 border rounded"
                              >
                                {element?.check_ins?.length !== 0 ? (
                                  userDetails && (
                                    <Mui.Table className="border">
                                      <Mui.TableHead
                                        sx={{
                                          backgroundColor: themes.primary,
                                          position: "sticky",
                                          top: -1,
                                          zIndex: 10,
                                        }}
                                      >
                                        <Mui.TableRow sx={tableRowSx}>
                                          <Mui.TableCell></Mui.TableCell>
                                          {workingHoursHeader.map((header) => (
                                            <Mui.TableCell
                                              sx={{
                                                color: themes.headLine,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {header.header}
                                            </Mui.TableCell>
                                          ))}

                                          <Mui.TableCell
                                            sx={{
                                              color: themes.headLine,
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Action
                                          </Mui.TableCell>

                                          <Mui.TableCell></Mui.TableCell>
                                        </Mui.TableRow>
                                      </Mui.TableHead>
                                      <Mui.TableBody>
                                        {userDetails?.checkin_details?.map(
                                          (shiftDetails, index) =>
                                            shiftDetails?.status === "HL" ||
                                            shiftDetails?.status === "L" ? (
                                              <>
                                                <Mui.TableRow
                                                  key={index}
                                                  sx={tableRowSx}
                                                >
                                                  <Mui.TableCell>
                                                    {" "}
                                                  </Mui.TableCell>
                                                  <Mui.TableCell>
                                                    {shiftDetails?.date}
                                                  </Mui.TableCell>
                                                  <Mui.TableCell>
                                                    {" "}
                                                  </Mui.TableCell>
                                                  <Mui.TableCell>
                                                    {" "}
                                                  </Mui.TableCell>
                                                  <Mui.TableCell>
                                                    {" "}
                                                  </Mui.TableCell>
                                                  <Mui.TableCell>
                                                    {" "}
                                                  </Mui.TableCell>
                                                  {shiftDetails?.status ===
                                                  "L" ? (
                                                    <Mui.TableCell></Mui.TableCell>
                                                  ) : (
                                                    <Mui.TableCell>
                                                      {
                                                        shiftDetails?.break_hours
                                                      }
                                                    </Mui.TableCell>
                                                  )}
                                                  {shiftDetails?.status ===
                                                  "L" ? (
                                                    <Mui.TableCell></Mui.TableCell>
                                                  ) : (
                                                    <Mui.TableCell>
                                                      {shiftDetails?.over_time}
                                                    </Mui.TableCell>
                                                  )}
                                                  {shiftDetails?.status ===
                                                  "L" ? (
                                                    <Mui.TableCell></Mui.TableCell>
                                                  ) : (
                                                    <Mui.TableCell>
                                                      {
                                                        shiftDetails?.working_hours
                                                      }
                                                    </Mui.TableCell>
                                                  )}
                                                  <Mui.TableCell>
                                                    {shiftDetails.status ===
                                                      "L" ||
                                                    shiftDetails.status ===
                                                      "H" ? (
                                                      <Mui.Typography>
                                                        {
                                                          shiftDetails.Leave_credit_hours
                                                        }
                                                      </Mui.Typography>
                                                    ) : shiftDetails.status ===
                                                      "HL" ? (
                                                      <Mui.Typography>
                                                        {
                                                          shiftDetails.Leave_credit_hours
                                                        }
                                                      </Mui.Typography>
                                                    ) : null}
                                                  </Mui.TableCell>
                                                  <Mui.TableCell>
                                                    <Mui.Typography
                                                      sx={{
                                                        display: "inline-block",
                                                        width: "28px",
                                                        color:
                                                          shiftDetails.status ===
                                                          "W"
                                                            ? themes?.headLine
                                                            : themes.whiteColor,
                                                        border:
                                                          shiftDetails.status ===
                                                          "W"
                                                            ? "1px solid black"
                                                            : "none",
                                                        height: "28px",
                                                        textAlign: "center",
                                                        lineHeight: "29px",
                                                        backgroundColor:
                                                          getColorWorkingHours(
                                                            shiftDetails.status
                                                          ),
                                                      }}
                                                    >
                                                      {shiftDetails.status ===
                                                      "HL" ? (
                                                        <Mui.Grid container>
                                                          <Mui.Typography
                                                            sx={{
                                                              ...attendanceStatusHalfBox,
                                                              backgroundColor:
                                                                shiftDetails.half_day_leave_period ===
                                                                "2nd"
                                                                  ? themes.greenColor
                                                                  : themes.yellowColor,
                                                            }}
                                                          >
                                                            H
                                                          </Mui.Typography>
                                                          <Mui.Typography
                                                            sx={{
                                                              ...attendanceStatusHalfBox,
                                                              backgroundColor:
                                                                shiftDetails.half_day_leave_period ===
                                                                "2nd"
                                                                  ? themes.yellowColor
                                                                  : themes.greenColor,
                                                            }}
                                                          >
                                                            L
                                                          </Mui.Typography>
                                                        </Mui.Grid>
                                                      ) : (
                                                        shiftDetails.status
                                                      )}
                                                    </Mui.Typography>
                                                  </Mui.TableCell>
                                                  <Mui.TableCell>
                                                    <Mui.IconButton
                                                      onClick={() => {
                                                        if (
                                                          checkFirstLevelApproverPermission(
                                                            userScreenAccess?.module_details,
                                                            "Reports",
                                                            "Reports"
                                                          )
                                                        ) {
                                                          if (
                                                            shiftDetails.shift !==
                                                              "Unassigned" &&
                                                            shiftDetails?.user_id !==
                                                              currentUserDetails?.id
                                                          ) {
                                                            setDepartmentIdValue(
                                                              shiftDetails?.department_id
                                                            );
                                                            setShiftDetails({
                                                              user_id:
                                                                shiftDetails?.user_id,
                                                              shift_filter_date:
                                                                shiftDetails?.date
                                                                  .split("-")
                                                                  .reverse()
                                                                  .join("-"),
                                                              date: shiftDetails?.date,
                                                              user_name:
                                                                shiftDetails?.user_name,
                                                              shift_name:
                                                                shiftDetails?.shift,
                                                              latest_pay_date:
                                                                shiftDetails?.latest_pay_date,
                                                              type: shiftDetails?.status,
                                                            });
                                                            setOpenSidePeek(
                                                              true
                                                            );
                                                          } else {
                                                            if (
                                                              shiftDetails?.user_id ===
                                                              currentUserDetails?.id
                                                            ) {
                                                              showToast(
                                                                "error",
                                                                "Your data cannot be edited by yourself"
                                                              );
                                                            } else {
                                                              showToast(
                                                                "error",
                                                                "Unassigned shifts cannot be edited"
                                                              );
                                                            }
                                                          }
                                                        } else {
                                                          showToast(
                                                            "error",
                                                            "Access denied: You are not authorized to modify the attendance record"
                                                          );
                                                        }
                                                      }}
                                                    >
                                                      <DriveFileRenameOutline />
                                                    </Mui.IconButton>
                                                  </Mui.TableCell>
                                                </Mui.TableRow>
                                              </>
                                            ) : (
                                              <>
                                                <Mui.TableRow
                                                  key={index}
                                                  sx={tableRowSx}
                                                >
                                                  <Mui.TableCell>
                                                    {shiftDetails?.date ===
                                                    breakExpandableDate ? (
                                                      <Mui.IconButton
                                                        onClick={() => {
                                                          setBreakExpandableDate(
                                                            0
                                                          );
                                                        }}
                                                      >
                                                        <KeyboardArrowDown />
                                                      </Mui.IconButton>
                                                    ) : (
                                                      <Mui.IconButton
                                                        onClick={() =>
                                                          setBreakExpandableDate(
                                                            shiftDetails?.date
                                                          )
                                                        }
                                                        style={{
                                                          padding: "0px",
                                                        }}
                                                      >
                                                        <ChevronRight />
                                                      </Mui.IconButton>
                                                    )}
                                                  </Mui.TableCell>
                                                  <Mui.TableCell>
                                                    {shiftDetails?.date}
                                                  </Mui.TableCell>
                                                  <Mui.TableCell>
                                                    {shiftDetails?.shift}
                                                  </Mui.TableCell>

                                                  <Mui.TableCell>
                                                    {
                                                      shiftDetails?.check_in_time_formatted
                                                    }
                                                  </Mui.TableCell>

                                                  <Mui.TableCell>
                                                    {
                                                      shiftDetails?.check_out_time_formatted
                                                    }
                                                  </Mui.TableCell>
                                                  {shiftDetails.status ===
                                                    "A" ||
                                                  shiftDetails.status ===
                                                    "W" ? (
                                                    <Mui.TableCell></Mui.TableCell>
                                                  ) : (
                                                    <Mui.TableCell>
                                                      {
                                                        shiftDetails?.break_hours
                                                      }
                                                    </Mui.TableCell>
                                                  )}

                                                  {shiftDetails.status ===
                                                    "A" ||
                                                  shiftDetails.status ===
                                                    "W" ? (
                                                    <Mui.TableCell></Mui.TableCell>
                                                  ) : (
                                                    <Mui.TableCell>
                                                      {shiftDetails?.shift_hours
                                                        ? shiftDetails?.shift_hours
                                                        : "N/A"}
                                                    </Mui.TableCell>
                                                  )}
                                                  {shiftDetails.status ===
                                                    "A" ||
                                                  shiftDetails.status ===
                                                    "W" ? (
                                                    <Mui.TableCell></Mui.TableCell>
                                                  ) : (
                                                    <Mui.TableCell>
                                                      {shiftDetails?.over_time}
                                                    </Mui.TableCell>
                                                  )}

                                                  {shiftDetails.status ===
                                                    "A" ||
                                                  shiftDetails.status ===
                                                    "W" ? (
                                                    <Mui.TableCell></Mui.TableCell>
                                                  ) : (
                                                    <Mui.TableCell>
                                                      {
                                                        shiftDetails?.working_hours
                                                      }
                                                    </Mui.TableCell>
                                                  )}
                                                  {shiftDetails.status ===
                                                    "A" ||
                                                  shiftDetails.status === "W" ||
                                                  shiftDetails.status === "P" ||
                                                  shiftDetails.status ===
                                                    "PR" ? (
                                                    <Mui.TableCell></Mui.TableCell>
                                                  ) : (
                                                    <Mui.TableCell>
                                                      {
                                                        shiftDetails?.Leave_credit_hours
                                                      }
                                                    </Mui.TableCell>
                                                  )}
                                                  <Mui.TableCell>
                                                    <Mui.Typography
                                                      sx={{
                                                        display: "inline-block",
                                                        width: "28px",
                                                        color:
                                                          shiftDetails.status ===
                                                          "W"
                                                            ? themes.headLine
                                                            : themes.whiteColor,
                                                        border:
                                                          shiftDetails.status ===
                                                          "W"
                                                            ? "1px solid black"
                                                            : "none",
                                                        height: "28px",
                                                        textAlign: "center",
                                                        lineHeight: "29px",
                                                        backgroundColor:
                                                          getColorWorkingHours(
                                                            shiftDetails.status
                                                          ),
                                                      }}
                                                    >
                                                      {shiftDetails.status ===
                                                        "PL" ||
                                                      shiftDetails.status ===
                                                        "LP" ||
                                                      shiftDetails.status ===
                                                        "AL" ||
                                                      shiftDetails.status ===
                                                        "LA" ? (
                                                        <Mui.Grid container>
                                                          {shiftDetails.status ===
                                                            "PL" && (
                                                            <>
                                                              <Mui.Typography
                                                                sx={{
                                                                  ...attendanceStatusHalfBox,
                                                                  backgroundColor:
                                                                    themes.greenColor,
                                                                }}
                                                              >
                                                                P
                                                              </Mui.Typography>
                                                              <Mui.Typography
                                                                sx={{
                                                                  ...attendanceStatusHalfBox,
                                                                  backgroundColor:
                                                                    themes.yellowColor,
                                                                }}
                                                              >
                                                                L
                                                              </Mui.Typography>
                                                            </>
                                                          )}
                                                          {shiftDetails.status ===
                                                            "LP" && (
                                                            <>
                                                              <Mui.Typography
                                                                sx={{
                                                                  ...attendanceStatusHalfBox,
                                                                  backgroundColor:
                                                                    themes.yellowColor,
                                                                }}
                                                              >
                                                                L
                                                              </Mui.Typography>
                                                              <Mui.Typography
                                                                sx={{
                                                                  ...attendanceStatusHalfBox,
                                                                  backgroundColor:
                                                                    themes.greenColor,
                                                                }}
                                                              >
                                                                P
                                                              </Mui.Typography>
                                                            </>
                                                          )}
                                                          {shiftDetails.status ===
                                                            "AL" && (
                                                            <>
                                                              <Mui.Typography
                                                                sx={{
                                                                  ...attendanceStatusHalfBox,
                                                                  backgroundColor:
                                                                    themes.redColor,
                                                                }}
                                                              >
                                                                A
                                                              </Mui.Typography>
                                                              <Mui.Typography
                                                                sx={{
                                                                  ...attendanceStatusHalfBox,
                                                                  backgroundColor:
                                                                    themes.yellowColor,
                                                                }}
                                                              >
                                                                L
                                                              </Mui.Typography>
                                                            </>
                                                          )}
                                                          {shiftDetails.status ===
                                                            "LA" && (
                                                            <>
                                                              <Mui.Typography
                                                                sx={{
                                                                  ...attendanceStatusHalfBox,
                                                                  backgroundColor:
                                                                    themes.yellowColor,
                                                                }}
                                                              >
                                                                L
                                                              </Mui.Typography>
                                                              <Mui.Typography
                                                                sx={{
                                                                  ...attendanceStatusHalfBox,
                                                                  backgroundColor:
                                                                    themes.redColor,
                                                                }}
                                                              >
                                                                A
                                                              </Mui.Typography>
                                                            </>
                                                          )}
                                                        </Mui.Grid>
                                                      ) : (
                                                        shiftDetails.status
                                                      )}
                                                    </Mui.Typography>
                                                  </Mui.TableCell>

                                                  <Mui.TableCell>
                                                    <>
                                                      <Mui.Grid
                                                        container
                                                        xs={12}
                                                      >
                                                        <Mui.Grid item xs={5}>
                                                          <Mui.IconButton
                                                            onClick={() => {
                                                              if (
                                                                checkFirstLevelApproverPermission(
                                                                  userScreenAccess?.module_details,
                                                                  "Reports",
                                                                  "Reports"
                                                                )
                                                              ) {
                                                                if (
                                                                  (shiftDetails.shift !==
                                                                    "Unassigned" &&
                                                                    shiftDetails?.user_id !==
                                                                      currentUserDetails?.id) ||
                                                                  (currentUserDetails?.type ===
                                                                    adminRoleName &&
                                                                    shiftDetails.shift !==
                                                                      "Unassigned")
                                                                ) {
                                                                  setDepartmentIdValue(
                                                                    shiftDetails?.department_id
                                                                  );
                                                                  setShiftDetails(
                                                                    {
                                                                      user_id:
                                                                        shiftDetails?.user_id,
                                                                      shift_filter_date:
                                                                        shiftDetails?.date
                                                                          .split(
                                                                            "-"
                                                                          )
                                                                          .reverse()
                                                                          .join(
                                                                            "-"
                                                                          ),
                                                                      date: shiftDetails?.date,
                                                                      user_name:
                                                                        shiftDetails?.user_name,
                                                                      shift_name:
                                                                        shiftDetails?.shift,
                                                                      latest_pay_date:
                                                                        shiftDetails?.latest_pay_date,
                                                                      type: shiftDetails?.status,
                                                                      image_url:
                                                                        shiftDetails?.image_url,
                                                                      employee_id:
                                                                        shiftDetails?.employee_id,
                                                                      department_name:
                                                                        shiftDetails?.department_name,
                                                                      user_type:
                                                                        shiftDetails?.user_type,
                                                                    }
                                                                  );
                                                                  setOpenSidePeek(
                                                                    true
                                                                  );
                                                                } else {
                                                                  if (
                                                                    shiftDetails?.user_id ===
                                                                    currentUserDetails?.id
                                                                  ) {
                                                                    showToast(
                                                                      "error",
                                                                      "Your data cannot be edited by yourself"
                                                                    );
                                                                  } else {
                                                                    showToast(
                                                                      "error",
                                                                      "Unassigned shifts cannot be edited"
                                                                    );
                                                                  }
                                                                }
                                                              } else {
                                                                showToast(
                                                                  "error",
                                                                  "Access denied: You are not authorized to modify the attendance record"
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            <DriveFileRenameOutline />
                                                          </Mui.IconButton>
                                                        </Mui.Grid>

                                                        <Mui.Grid
                                                          item
                                                          xs={5}
                                                        ></Mui.Grid>
                                                      </Mui.Grid>
                                                    </>
                                                  </Mui.TableCell>
                                                  <Mui.TableCell></Mui.TableCell>
                                                </Mui.TableRow>

                                                {breakExpandableDate ===
                                                  shiftDetails?.date && (
                                                  <Mui.TableRow sx={tableRowSx}>
                                                    <Mui.TableCell colSpan={15}>
                                                      <Mui.TableContainer
                                                        sx={{
                                                          marginTop: 0,
                                                          marginLeft: "auto",
                                                          marginRight: "auto",
                                                          width: "100%",
                                                        }}
                                                        className="w-96 border rounded"
                                                      >
                                                        {shiftDetails
                                                          ?.break_details
                                                          ?.length !== 0 ? (
                                                          <Mui.Table className="border">
                                                            <Mui.TableHead
                                                              sx={{
                                                                backgroundColor:
                                                                  themes.primary,
                                                              }}
                                                            >
                                                              <Mui.TableRow
                                                                sx={tableRowSx}
                                                              >
                                                                <Mui.TableCell
                                                                  sx={{
                                                                    color:
                                                                      themes.headLine,
                                                                    fontWeight:
                                                                      "bold",
                                                                  }}
                                                                >
                                                                  Break Start
                                                                </Mui.TableCell>
                                                                <Mui.TableCell
                                                                  sx={{
                                                                    color:
                                                                      themes.headLine,
                                                                    fontWeight:
                                                                      "bold",
                                                                  }}
                                                                >
                                                                  Break End
                                                                </Mui.TableCell>
                                                                <Mui.TableCell
                                                                  sx={{
                                                                    color:
                                                                      themes.headLine,
                                                                    fontWeight:
                                                                      "bold",
                                                                  }}
                                                                >
                                                                  Break-Time
                                                                </Mui.TableCell>
                                                              </Mui.TableRow>
                                                            </Mui.TableHead>
                                                            <Mui.TableBody>
                                                              {shiftDetails?.break_details?.map(
                                                                (
                                                                  shift,
                                                                  index
                                                                ) => (
                                                                  <Mui.TableRow
                                                                    key={index}
                                                                    sx={
                                                                      tableRowSx
                                                                    }
                                                                  >
                                                                    <Mui.TableCell>
                                                                      {
                                                                        shift?.break_out
                                                                      }
                                                                    </Mui.TableCell>

                                                                    <Mui.TableCell>
                                                                      {
                                                                        shift?.break_in
                                                                      }
                                                                    </Mui.TableCell>

                                                                    <Mui.TableCell>
                                                                      {
                                                                        shift?.individual_break_time
                                                                      }
                                                                    </Mui.TableCell>
                                                                  </Mui.TableRow>
                                                                )
                                                              )}
                                                            </Mui.TableBody>
                                                          </Mui.Table>
                                                        ) : (
                                                          <Mui.Stack
                                                            sx={{
                                                              padding: 0.5,
                                                            }}
                                                            spacing={2}
                                                            fullWidthy
                                                          >
                                                            <Mui.Alert severity="info">
                                                              There is a no
                                                              available breaks
                                                            </Mui.Alert>
                                                          </Mui.Stack>
                                                        )}
                                                      </Mui.TableContainer>
                                                    </Mui.TableCell>
                                                  </Mui.TableRow>
                                                )}
                                              </>
                                            )
                                        )}
                                      </Mui.TableBody>
                                      <Mui.TableBody>
                                        <Mui.TableRow sx={tableRowSx}>
                                          <Mui.TableCell></Mui.TableCell>
                                          <Mui.TableCell></Mui.TableCell>
                                          <Mui.TableCell></Mui.TableCell>
                                          <Mui.TableCell></Mui.TableCell>
                                          <Mui.TableCell></Mui.TableCell>
                                          <Mui.TableCell></Mui.TableCell>
                                          <Mui.TableCell>
                                            <Mui.Typography>
                                              Total
                                            </Mui.Typography>
                                          </Mui.TableCell>
                                          <Mui.TableCell>
                                            {" "}
                                            {userDetails?.total_over_time}
                                          </Mui.TableCell>
                                          <Mui.TableCell>
                                            {userDetails?.total_working_hours}
                                          </Mui.TableCell>
                                          <Mui.TableCell>
                                            {" "}
                                            {
                                              userDetails?.total_leave_credit_hours
                                            }
                                          </Mui.TableCell>
                                          <Mui.TableCell></Mui.TableCell>
                                        </Mui.TableRow>
                                      </Mui.TableBody>
                                    </Mui.Table>
                                  )
                                ) : (
                                  <Mui.Stack
                                    sx={{ padding: 0.5 }}
                                    spacing={2}
                                    fullWidthy
                                  >
                                    <Mui.Alert severity="info">
                                      There is a no available shifts
                                    </Mui.Alert>
                                  </Mui.Stack>
                                )}
                              </Mui.TableContainer>
                            </Mui.TableCell>
                          </Mui.TableRow>
                        ) : null}
                      </>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
          <Mui.Grid
            container
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            {workingHoursDetails?.length > 25 && (
              <Mui.TablePagination
                className="custom-pagination"
                component="div"
                rowsPerPageOptions={[25, 50, 75, 100]}
                count={workingHoursDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                loading={loading}
              />
            )}
          </Mui.Grid>
        </Mui.Grid>
      ) : loading ? (
        <Loader info="Loading..." />
      ) : reportedType === "Punch details" ? (
        <PunchDetails
          masterPunchDetails={masterPunchDetails}
          departmentId={departmentId}
          startDate={startDate}
          endDate={endDate}
          departmentName={departmentName}
          shiftCategoryName={shiftCatagoryName}
          selectedDateRange={selectedDateRange}
          removeExpand={removeExpand}
          setRemoveExpand={setRemoveExpand}
          fetchPunchDetails={fetchPunchDetails}
          setFetchPunchDetails={setFetchPunchDetails}
          setPunchExports={setPunchExports}
          page={page}
          setLeavePage={setLeavePage}
          rowsPerPage={rowsPerPage}
          setLeaveRowsPerPage={setLeaveRowsPerPage}
          punchExports={punchExports}
          punchDetailsData={punchDetailsData}
        />
      ) : (
        <OtReports
          workingHoursDetails={workingHoursDetails}
          exportOTime={exportOTime}
          exportOverTimeReport={exportOverTimeReport}
          departmentName={departmentName}
          shiftCatagoryName={shiftCatagoryName}
          startDate={startDate}
          endDate={endDate}
        />
      )}
      {openSidePeek ? (
        <EditCheckInOut
          setOpenSidePeek={setOpenSidePeek}
          openSidePeek={openSidePeek}
          shiftDetails={shiftDetails}
          setEditState={setEditState}
          departmentId={departmentIdValue}
        />
      ) : null}
    </React.Fragment>
  );
};

const ContentGrid = styled(Mui.Grid)`
  width: 80%;
`;
